<template>
  <div class="grid gap-1">
    <label v-if="label" :for="id" class="text-base">{{ label }} </label>
    <VueDatePicker v-bind="$attrs" />
  </div>
</template>

<script setup>
import { VueDatePicker } from "@vuepic/vue-datepicker";

defineProps({ label: String, id: String });
</script>
